import React from 'react'
import { MenuItem } from '@material-ui/core'

import PageLink from '../../../PageLink'

const Item = ({ children, to, ...other }) => (
  <MenuItem {...other}>
    <PageLink to={to}>{children}</PageLink>
  </MenuItem>
)

export default Item
